import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { SettingsWidget as mainModule } from './main';
import * as $ from 'jquery';

declare var require: any;
require('../sass-main/pdc-widget-settings.sass');

export class SettingsWidget extends WidgetBase {
    public static _name: string = 'Application Settings';
    public static group = 'Administrative';
    public static moduleName: string = 'pdc-widget-settings';
    public static icon: string = 'wrench';

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-settings'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(SettingsWidget);
